const GA4_MEASUREMENT_ID = /^G-[A-Z0-9]+$/i;

/** Identificador público autorizado para a propriedade Google Analytics da EquipaPRO. */
export const DEFAULT_GA4_MEASUREMENT_ID = "G-DVVJRVRLE1";

/** Aceita somente identificadores públicos de medição GA4. */
export function normalizeGa4MeasurementId(value?: string | null): string | null {
  const normalized = value?.trim().toUpperCase();
  return normalized && GA4_MEASUREMENT_ID.test(normalized) ? normalized : null;
}
